import React from 'react';

// Golden lotus + Om mark used in the header / logo
export const LotusOm = ({ className = '', size = 44 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="goldgrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#F5D97A" />
        <stop offset="55%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#B38B22" />
      </linearGradient>
    </defs>
    {/* Om symbol */}
    <text x="32" y="20" textAnchor="middle" fontSize="18" fill="url(#goldgrad)" fontFamily="serif" fontWeight="700">ॐ</text>
    {/* Lotus petals */}
    <g fill="url(#goldgrad)" stroke="#B38B22" strokeWidth="0.6">
      <path d="M32 26c-3 5-3 11 0 16 3-5 3-11 0-16z" />
      <path d="M32 30c-6 3-9 8-9 14 6-1 10-5 12-11-1-1-2-2-3-3z" />
      <path d="M32 30c6 3 9 8 9 14-6-1-10-5-12-11 1-1 2-2 3-3z" />
      <path d="M22 33c-6 0-11 3-14 8 6 2 12 1 16-3-1-2-1-3-2-5z" />
      <path d="M42 33c6 0 11 3 14 8-6 2-12 1-16-3 1-2 1-3 2-5z" />
    </g>
  </svg>
);

// Ornamental divider with a small lotus / diamond motif
export const OrnDivider = ({ className = '', tone = '#D4AF37' }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden="true">
    <span className="h-px w-10 md:w-16" style={{ background: `linear-gradient(90deg, transparent, ${tone})` }} />
    <svg width="26" height="14" viewBox="0 0 26 14" fill="none">
      <path d="M13 0l3 4-3 3-3-3 3-4z" fill={tone} />
      <path d="M13 7c-3 2-6 3-10 3 4 3 8 3 10 1 2 2 6 2 10-1-4 0-7-1-10-3z" fill={tone} opacity="0.75" />
    </svg>
    <span className="h-px w-10 md:w-16" style={{ background: `linear-gradient(90deg, ${tone}, transparent)` }} />
  </div>
);

// Small diamond bullet used between nav / marquee items
export const Diamond = ({ className = '', tone = '#D4AF37', size = 8 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 10 10" aria-hidden="true">
    <path d="M5 0l5 5-5 5-5-5 5-5z" fill={tone} />
  </svg>
);

// Glowing diya (oil lamp) for decorative parallax accents
export const Diya = ({ className = '', size = 64 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 80 80" fill="none" aria-hidden="true">
    <defs>
      <radialGradient id="flameg" cx="50%" cy="40%" r="60%">
        <stop offset="0%" stopColor="#FFF3C4" />
        <stop offset="55%" stopColor="#FFB347" />
        <stop offset="100%" stopColor="#E8791B" />
      </radialGradient>
      <linearGradient id="bowlg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#8A5A12" />
      </linearGradient>
    </defs>
    <ellipse cx="40" cy="70" rx="22" ry="4" fill="#000" opacity="0.15" />
    <path className="animate-flame" style={{ transformOrigin: '40px 44px' }} d="M40 20c5 8 8 12 8 19a8 8 0 11-16 0c0-5 3-9 8-19z" fill="url(#flameg)" />
    <path d="M18 52c4 8 40 8 44 0-2 8-8 12-22 12s-20-4-22-12z" fill="url(#bowlg)" />
  </svg>
);
